import React from 'react';
import "./index.css";

export default () => {
    return (
        <div class="loading-wrap"><img src="/loading.gif" alt="loading..." /></div>
    )
}
